<template>
  <label
    class="field-wrapper"
    :class="{
      'has-error': props.error,
      'has-value': model !== '',
      'is-loading': props.isLoading
    }"
  >
    <DeployerUiFormLabel
      :label="props.label"
      :tooltip="props.tooltip"
      v-if="props.label"
    />
    <div class="field">
      <span v-if="props.svgIcon" class="icon-wrapper" v-html="props.svgIcon">
      </span>
      <div class="input-wrapper">
        <textarea v-model="model" class="input"></textarea>

        <div
          class="placeholder"
          v-if="props.placeholder"
          v-html="placeholder"
        ></div>
      </div>
      <div v-if="props.selectValues.length > 0" class="select">
        <button
          v-for="option in props.selectValues"
          :key="`btn-${option}`"
          type="button"
          class="select-button"
          :class="{ selected: option === props.selectedValue }"
          :disabled="props.selectValues.length === 1"
          @click.prevent="emits('selectValue', option)"
        >
          {{ option }}
        </button>
      </div>
      <div v-if="props.error" class="error">
        {{ error }}
      </div>
    </div>
  </label>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  placeholderIcon: {
    type: String,
    default: ''
  },
  tooltip: {
    type: String,
    default: ''
  },
  selectValues: {
    type: Array,
    default: () => []
  },
  selectedValue: {
    type: String,
    default: ''
  },
  error: {
    type: String,
    default: ''
  },
  svgIcon: {
    type: String,
    default: ''
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})
const model = defineModel()

const emits = defineEmits(['selectValue'])
</script>

<style lang="scss" scoped>
.field-wrapper {
  display: block;
  letter-spacing: 0.15px;
}

.input-wrapper {
  flex: 1 1 0;
  position: relative;
  letter-spacing: 0.15px;
}

.input {
  display: block;
  padding-inline: 0px;
  padding-top: 14px;
  font-size: 1.5rem;
  border: 0;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  letter-spacing: 0.15px;
  min-height: 170px;
  background: transparent;
  &:focus {
    outline: none;
  }
}

.field {
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;
  border-radius: 10px;
  border: 1px solid var(--field-stroke, rgba(0, 0, 0, 0.2));

  width: 100%;
  padding-left: 20px;
  .has-error & {
    border-color: #d83737;
  }
}

.placeholder {
  color: var(--Text, #000);
  opacity: 0.5;
  font-weight: 500;
  font-size: 1.5rem;
  position: absolute;
  left: 0;
  top: 14px;
  pointer-events: none;
  transition: opacity 0.4s, transform 0.4s;

  .has-value & {
    opacity: 0;
    transform: translateX(15px);
  }
}

.select {
  position: absolute;
  top: 9px;
  bottom: 9px;
  right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.05);
  padding: 4px;
  display: flex;
  gap: 8px;
}

.select-button {
  line-height: 100%;
  font-size: 1.2rem;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
  letter-spacing: 0.12px;
  border-radius: 8px;
  height: 24px;
  width: 34px;
  text-align: center;
  transition: background 0.2s, box-shadow 0.2s;

  &:hover:not([disabled]),
  &.selected {
    background: #fff;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
  }

  &[disabled]:hover {
    cursor: default;
  }
}

.error {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;

  color: #d83737;
  margin-top: 2px;
  font-size: 1.2rem;
}

.icon-wrapper {
  width: 17px;
  padding-top: 1px;
  :deep(svg) {
    width: 17px;
    height: 17px;
    display: block;
    transition: opacity 0.2s;
    * {
      stroke: #000;
    }
  }

  .is-loading & {
    background: url(/images/loading.gif) no-repeat bottom center;
    background-size: 17px 17px;

    :deep(svg) {
      opacity: 0;
    }
  }
}
</style>
